import { Component } from "@angular/core";
import { ModelService } from "../Services/model.service";
import { ValidFeatureSystem } from "../Model/ValidFeatureSystem";
import { ValidFeature } from "../Model/ValidFeature";


@Component({
  selector: "validFeatureSystem",
  templateUrl: "validFeatureSystem.component.html"
})
export class ValidFeatureSystemComponent {


  validFeatureSystems: ValidFeatureSystem[] = [];
  validFeatures: ValidFeature[] = [];
  selectedValidFeatureSystem: ValidFeatureSystem = new ValidFeatureSystem()

  constructor(public modelService: ModelService) {
    this.modelService.validFeatureService.getSystems(this.modelService.loginService.currentUser.customerId).subscribe(
      (result: ValidFeatureSystem[]) => {
        this.validFeatureSystems = result
      });
  }

  onRowClick(event: any) {
    this.modelService.validFeatureService.getFeatures(event.data.id, this.modelService.loginService.currentUser.customerId).subscribe(
      (result: ValidFeature[]) => {
        this.validFeatures = result
      });
    this.selectedValidFeatureSystem.name = event.data.name
  }

}
